import axios, { AxiosInstance } from 'axios';
import { API_CONFIG } from './staticDataConfig';

// CORREÇÃO: Usar configuração dinâmica em vez de URL hardcoded
const api: AxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,  // Usar configuração dinâmica
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

/**
 * Interceptor de request - CRÍTICO para autenticação
 */
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
//       console.log(`[API] Token adicionado à requisição ${config.method?.toUpperCase()} ${config.url}`);
    } else {
//       console.warn(`[API] Token não encontrado para ${config.method?.toUpperCase()} ${config.url}`);
    }
    
    return config;
  },
  (error) => {
    console.error('[API] Erro no interceptor de request:', error);
    return Promise.reject(error);
  }
);

/**
 * Interceptor de response - SIMPLIFICADO e SEGURO
 */
api.interceptors.response.use(
  (response) => {
//     console.log(`[API] Resposta recebida ${response.status} para ${response.config.method?.toUpperCase()} ${response.config.url}`);
    return response;
  },
  (error) => {
    const config = error.config;
    const response = error.response;
    
    // SILENCIAR logs de 404 para prontuários (esperado quando não existe)
    const isProntuarioNotFound = 
      response?.status === 404 && 
      config?.url?.includes('/prontuarios/');
    
    if (!isProntuarioNotFound) {
      console.error(`[API] Erro na requisição ${config?.method?.toUpperCase()} ${config?.url}:`, {
        status: response?.status,
        statusText: response?.statusText,
        data: response?.data
      });
    } else {
//       console.log(`[API] Prontuário não encontrado (esperado): ${config?.url}`);
    }
    
    // CRÍTICO: Verificar 402 (Plano Expirado)
    const status = response?.status;
    if (status === 402) {
      const codigo = response?.data?.codigo;
      const mensagem = response?.data?.mensagem || 'Seu plano expirou';
      
      console.warn('[API] ⛔ Status 402 - Plano expirado:', {
        codigo,
        mensagem
      });
      
      // Redirecionar para página de pagamento APENAS se não estiver já nela
      // (evita loop infinito quando a própria tela de pagamento faz requisições)
      const rotasPermitidas = ['/pagamento', '/onboarding', '/cadastro'];
      const estaEmRotaPermitida = rotasPermitidas.some(r => window.location.pathname.startsWith(r));
      if (!estaEmRotaPermitida) {
        window.location.href = '/pagamento';
      }
      
      // Mostrar mensagem amigável
      error.friendlyMessage = mensagem;
      
      return Promise.reject(error);
    }
    
    // Mapear mensagens amigáveis
    let friendlyMessage: string | null = null;
    const erroCodigo = response?.data?.erro;
    const rawMensagem = response?.data?.mensagem;

    if (status === 401) {
      friendlyMessage = 'Sessão inválida ou expirada. Faça login novamente.';
    } else if (status === 403) {
      friendlyMessage = rawMensagem || 'Acesso negado. Você não possui permissão para esta operação.';
      if (erroCodigo === 'LIMITE_USUARIOS_ESTUDANTE') {
        friendlyMessage = 'Plano estudante não permite criar outros usuários.';
      } else if (erroCodigo === 'ESTUDANTE_EDITA_APENAS_PROPRIO_USUARIO') {
        friendlyMessage = 'No plano estudante você só pode editar seu próprio usuário.';
      } else if (erroCodigo === 'ESTUDANTE_PROIBE_ALTERAR_STATUS_OUTROS') {
        friendlyMessage = 'No plano estudante não é permitido alterar o status de outros usuários.';
      } else if (erroCodigo === 'ESTUDANTE_PROIBE_RESETAR_SENHA_OUTROS') {
        friendlyMessage = 'No plano estudante não é permitido resetar senha de outros usuários.';
      }
    } else if (status === 404) {
      friendlyMessage = rawMensagem || 'Recurso não encontrado.';
    } else if (status === 409) {
      if (erroCodigo === 'USUARIO_POSSUI_DEPENDENCIAS') {
        const d = response?.data?.detalhes;
        friendlyMessage = `Não é possível excluir: usuário possui vínculos (Pacientes: ${d?.pacientes || 0}, Consultas: ${d?.consultas || 0}, Prontuários: ${d?.prontuarios || 0}). Transfira primeiro.`;
      } else {
        friendlyMessage = rawMensagem || 'Operação em conflito com estado atual.';
      }
    } else if (status === 429) {
      if (erroCodigo === 'LIMITE_USUARIOS_EMPRESA') {
        friendlyMessage = rawMensagem || 'Limite de usuários atingido para este tipo de empresa.';
      } else if (rawMensagem) {
        friendlyMessage = rawMensagem;
      } else {
        friendlyMessage = 'Limite ou quota atingido. Tente novamente mais tarde.';
      }
    } else if (status && status >= 500) {
      friendlyMessage = 'Erro interno do servidor. Tente novamente em instantes.';
    }

    if (friendlyMessage) {
      // Expor mensagem amigável para camadas superiores
      error.friendlyMessage = friendlyMessage;
    }

    return Promise.reject(error);
  }
);

// CORREÇÃO: Adicionar exportação da função abortAllPendingRequests
export const abortAllPendingRequests = () => {
//   console.log('[API] Abortando todas as requisições pendentes');
  // Implementação para cancelar requisições usando axios.CancelToken
  // Por enquanto, apenas log para evitar quebrar a aplicação
};

export default api;
export { api };

// Re-exportar serviços
export * from './api/consultasService';
export * from './api/pacientesService';
export * from './api/usuariosService';
export * from './api/catalogoService';
export * from './api/prontuariosService';
export * from './api/relatoriosService';
export * from './api/registroService';
export * from './api/consultasRecorrentesService';
